const PRESETS = {
  default: { maximumFractionDigits: 2 },
  currency: { style: 'currency' },
  milliliters: { style: 'unit', unit: 'milliliter', unitDisplay: 'narrow' },
  seconds: { style: 'unit', unit: 'second', unitDisplay: 'narrow' },
} as const satisfies Record<string, Intl.NumberFormatOptions>;

type FormatPreset = keyof typeof PRESETS;

const cache = new Map<string, Intl.NumberFormat>();

let currentLocale = 'en';

export function setNumberFormatLocale(locale: string) {
  currentLocale = locale;
  cache.clear();
}

export function formatNumber(
  value: number,
  preset?: FormatPreset,
  overrides?: Intl.NumberFormatOptions
): string;
export function formatNumber(
  value: number | null | undefined,
  preset?: FormatPreset,
  overrides?: Intl.NumberFormatOptions
): string | null | undefined;
export function formatNumber(
  value: number | null | undefined,
  preset: FormatPreset = 'default',
  overrides: Intl.NumberFormatOptions = {}
): string | null | undefined {
  if (value === null || value === undefined) {
    return value;
  }

  const options = { ...PRESETS[preset], ...overrides };

  // Key is options-only; locale changes clear the entire cache via setNumberFormatLocale
  const key = JSON.stringify(options);

  if (!cache.has(key)) {
    cache.set(key, new Intl.NumberFormat(currentLocale, options));
  }

  return cache.get(key)!.format(value);
}
